<footer class="footer">
  <img
    class="footer__image"
    src="assets/images/footer-financiacion.png"
    alt="Plan de Recuperación, Transformación y Resiliencia - Financiado por la Unión Europea - Next Generation EU. Gobierno de España, Ministerio de Industria y Turismo, Junta de Extremadura y Diputación de Cáceres."
    height="209"
  >
</footer>
